import { defineMessages } from "react-intl"

export default defineMessages({
  title: {
    id: "app.pages.profile.ProfileCreation.title",
  },
  footer: {
    id: "app.pages.profile.ProfileCreation.footer",
  },
  playtestTypes: {
    id: "app.pages.profile.Playtests.playtestTypes",
  },
  'playtestTypes.Remote': {
    id: "app.pages.profile.Playtests.playtestTypes.Remote",
  },
  'playtestTypes.Studio': {
    id: "app.pages.profile.Playtests.playtestTypes.Studio",
  },
  'playtestTypes.Mobile': {
    id: "app.pages.profile.Playtests.playtestTypes.Mobile",
  },
  'playtestTypes.VR': {
    id: "app.pages.profile.Playtests.playtestTypes.VR",
  },
  'playtestTypes.ToolsSoftware': {
    id: "app.pages.profile.Playtests.playtestTypes.ToolsSoftware",
  },
  availabilities: {
    id: "app.components.AboutYou.availabilities",
  },
  gaminghabits: {
    id: "app.pages.profile.ProfileCreation.gaminghabits",
  },
  languages: {
    id: "app.components.Language.languages",
  },
  confirmationTitle: {
    id: "app.pages.profile.ProfileCreation.confirmationTitle",
  },
  confirmationSubTitle: {
    id: "app.pages.profile.ProfileCreation.confirmationSubTitle",
  },
  finishLater: {
    id: "app.pages.profile.ProfileCreation.finishLater",
  },
  confirmationFooter: {
    id: "app.pages.profile.ProfileCreation.confirmationFooter",
  }
})
